const initialState = {
  vouchers: [],
};

export default function voucherReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_VOUCHERS":
      return {
        ...state,
        vouchers: action.vouchers,
      };
    default:
      return {
        ...state,
      };
  }
}
